import React, { HTMLProps, useState } from "react";
import "./styles.css";

interface ButtonProps extends HTMLProps<HTMLButtonElement> {
  classNameButton?: string;
  classNameDiv?: string;
  titleButton: string | React.ReactNode;
  able?: boolean;
  type?: "button" | "submit" | "reset";
}
export const Button = ({
  classNameButton,
  classNameDiv,
  titleButton,
  type,
  able,
  ...rest
}: ButtonProps) => {
  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "10px",
      }}
      className={classNameDiv}
    >
      <button
        type={type || "button"}
        className={classNameButton || "btnAlterar responsiveButton"}
        {...rest}
      >
        {titleButton}
      </button>
    </div>
  );

};
